import ua from "./ua";
import en from "./en";
import pl from "./pl";
import pt from "./pt";
import es from "./es";

export const ALL_LANGS = ["ua", "en", "pl", "pt", "es"] as const;
export type Lang = (typeof ALL_LANGS)[number];

export const DICTS: Record<Lang, Record<string, string>> = { ua, en, pl, pt, es };
